module.exports = "/assets/40d77a2abc546938d3c2a19cd5c63b7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/touchdown_icon.png
// module id = 232
// module chunks = 0